import { WithStyles, withStyles } from '@mui/styles';

import { SSOUserRequestCreated } from './ssoUserRequestCreated';
import { muiStyles } from './styles';

export type SSOUserRequestCreatedProps = WithStyles<typeof muiStyles>;

export default withStyles(muiStyles)(SSOUserRequestCreated);